import {createReducer} from "redux-act";
import {
	openVoteConfirmationModal,
	closeVoteConfirmationModal,
	openBudweiserTermsModal,
	closeBudweiserTermsModal,
	IVote,
} from "apps/BUDWEISERPOTM/modules/actions";

export interface IModalsReducer {
	voteConfirmationModalRound?: number;
	budweiserTermsModal: {
		isOpen: boolean;
		data?: IVote;
	};
}

const initial: IModalsReducer = {
	voteConfirmationModalRound: undefined,
	budweiserTermsModal: {
		isOpen: false,
	},
};

export const modals = createReducer<IModalsReducer>({}, initial)
	.on(openVoteConfirmationModal, (state, roundId) => ({
		...state,
		voteConfirmationModalRound: roundId,
	}))
	.on(closeVoteConfirmationModal, (state) => ({
		...state,
		voteConfirmationModalRound: undefined,
	}))
	.on(openBudweiserTermsModal, (state, payload) => ({
		...state,
		budweiserTermsModal: {
			isOpen: true,
			data: payload.data,
		},
	}))
	.on(closeBudweiserTermsModal, (state) => ({
		...state,
		budweiserTermsModal: {
			isOpen: false,
			data: undefined,
		},
	}));
